// `slug` is the short, stable identifier used in archive filter URLs (e.g. ?target_group=cities).
// It must stay unique within its own group and should not change once shipped, as it appears in
// shared/bookmarked links. `key` remains the canonical id used in the DB and as the i18n key.
export const CMS_TAXONOMY_TARGET_GROUP = Object.freeze({
  VOLUNTEERS: { id: 1, key: 'taxonomy_target_group_volunteers', slug: 'volunteers', colors: { base: '#BCF4F5' } },
  NPOS: { id: 2, key: 'taxonomy_target_group_orgs', slug: 'organisations', colors: { base: '#FFD8A8' } },
  COMPANIES: { id: 3, key: 'taxonomy_target_group_companies', slug: 'companies', colors: { base: '#CDB8FF' } },
  CITIES: { id: 4, key: 'taxonomy_target_group_cities', slug: 'cities', colors: { base: '#B4EBCA' } },
})

export const CMS_TAXONOMY_BLOG_TYPES = Object.freeze({
  GUIDES_HOWTOS: { id: 5, key: 'taxonomy_blog_type_guides_howtos', slug: 'guides' },
  INSPIRATION_STORIES: { id: 6, key: 'taxonomy_blog_type_inspiration_stories', slug: 'inspiration' },
  NEWS_UPDATES: { id: 7, key: 'taxonomy_blog_type_news_updates', slug: 'news' },
  TIPS_BEST_PRACTICES: { id: 8, key: 'taxonomy_blog_type_tips_best_practices', slug: 'tips' },
  POLICY_LEGISLATION: { id: 9, key: 'taxonomy_blog_type_policy_legislation', slug: 'policy' },
})

export const CMS_TAXONOMY_HELPDESK_TYPES = Object.freeze({
  GETTING_STARTED: { id: 10, key: 'taxonomy_helpdesk_type_getting_started', slug: 'getting-started' },
  ACCOUNT_SETTINGS: { id: 11, key: 'taxonomy_helpdesk_type_account_settings', slug: 'account' },
  PROJECTS_ACTIVITIES: { id: 12, key: 'taxonomy_helpdesk_type_projects_activities', slug: 'projects' },
  PAYMENTS_INVOICING: { id: 13, key: 'taxonomy_helpdesk_type_payments_invoicing', slug: 'payments' },
  TECHNICAL_ISSUES: { id: 14, key: 'taxonomy_helpdesk_type_technical_issues', slug: 'technical' },
})

export const CMS_TAXONOMY_BY_CONTENT_TYPE = Object.freeze({
  blog: [
    { groupKey: 'taxonomy_group_target_group', terms: CMS_TAXONOMY_TARGET_GROUP },
    { groupKey: 'taxonomy_group_blog_types', terms: CMS_TAXONOMY_BLOG_TYPES },
  ],
  helpdesk: [
    { groupKey: 'taxonomy_group_target_group', terms: CMS_TAXONOMY_TARGET_GROUP },
    { groupKey: 'taxonomy_group_helpdesk_types', terms: CMS_TAXONOMY_HELPDESK_TYPES },
  ],
  page: [],
})

export const getCmsTaxonomyTermsByContentType = (contentType) =>
  (CMS_TAXONOMY_BY_CONTENT_TYPE[contentType] ?? []).flatMap(({ terms }) => Object.values(terms))
